import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Grid } from '../../../app/StyleGuide';
import { Button } from '../../../components/Buttons';
import { ChurchAccount } from '../models/churchAccount';
import { getAccountText } from '../utils/getAccountText';
import { redirectToCreateChurchAccount } from '../utils/redirectToCreateChurchAccount';
import { ChurchConnectedItem, ChurchItem } from './ChurchItem';
import { ButtonRow, Header, Subtitle, Title } from './ConnectChurchAccountModalElements';
import { ChurchAccountRedirect } from '../state/churchAccountRedirect';

const ChurchList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${Grid._3};
  overflow-y: auto;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    gap: ${Grid._4};
  }
`;

type ConnectChurchAccountSelectionScreenProps = {
  churchAccounts: ChurchAccount[];
  onSelectChurchAccount: (account: ChurchAccount) => void;
  churchAccountRedirect: ChurchAccountRedirect;
};

export const ConnectChurchAccountSelectionScreen = ({
  churchAccounts,
  onSelectChurchAccount,
  churchAccountRedirect,
}: ConnectChurchAccountSelectionScreenProps) => (
  <>
    <Header>
      <Title>Select Your Lifeway Church Account</Title>
      <Subtitle>
        Choose the church account you want to sync to your Ministry Grid church or create a new church account
      </Subtitle>
    </Header>

    <ChurchList>
      {churchAccounts.map(account =>
        account.orgId ? (
          <ChurchConnectedItem key={account.churchAccountId} name={account.name} meta={getAccountText(account)} />
        ) : (
          <ChurchItem
            key={account.churchAccountId}
            name={account.name}
            meta={getAccountText(account)}
            onSelect={() => onSelectChurchAccount(account)}
          />
        )
      )}
    </ChurchList>

    <ButtonRow>
      <Button
        onClick={() => redirectToCreateChurchAccount(churchAccountRedirect)}
        data-tracking-id="create-new-church-account"
      >
        Create New Church Account
      </Button>
    </ButtonRow>
  </>
);
